module.exports = __webpack_public_path__ + "public/SiteIcons/heartrIconOff.svg?f4eb172d";